<template>
  <div>
    <div class="query-param-to-event">
      <!-- eslint-disable max-len -->
      <p>This page allows triggering custom Javascript events (to open the aiaibot Web Chat) via the Query parameter in the URL.<br>
        To use this, just add the following to the URL: <code>?aiaibot-custom-event=EVENTNAME</code> and replace <code>EVENTNAME</code> with the event name of your choice.</p>
      <!-- eslint-enable max-len -->
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    script: [
      { src: '/experiments/query-param-to-event.js' },
    ],
  },
};
</script>
